import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconFingerLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.073 21.25a3.747 3.747 0 0 1-2.858-1.314l-4.994-5.825a.96.96 0 0 1-.218-.685.835.835 0 0 1 .35-.62l.286-.21a1.776 1.776 0 0 1 1.02-.364 1.7 1.7 0 0 1 1.043.299l1.721 1.096V3.75c0-.212.072-.39.216-.534A.726.726 0 0 1 9.173 3c.213 0 .391.072.535.216a.725.725 0 0 1 .215.534v10.971c0 .363-.157.628-.472.795a.853.853 0 0 1-.924-.047l-1.708-1.092a.32.32 0 0 0-.173-.048.281.281 0 0 0-.173.057l-.029.02 4.1 4.802c.17.2.35.34.538.42.188.082.42.122.699.122h4.392a2.18 2.18 0 0 0 1.596-.661c.442-.44.664-.97.664-1.589v-6.942a.73.73 0 0 1 .215-.535.726.726 0 0 1 .535-.215c.213 0 .39.072.534.215a.727.727 0 0 1 .216.535V17.5c0 1.036-.369 1.92-1.105 2.652-.736.732-1.621 1.098-2.655 1.098h-4.1Zm.437-14.538c.213 0 .39.071.534.215a.726.726 0 0 1 .216.535v4.288c0 .213-.072.39-.216.534a.726.726 0 0 1-.535.216.724.724 0 0 1-.534-.216.726.726 0 0 1-.215-.534V7.462a.73.73 0 0 1 .215-.535.726.726 0 0 1 .535-.215Zm3.337 1.096c.212 0 .39.072.534.215a.727.727 0 0 1 .215.535v3.192c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216.724.724 0 0 1-.534-.216.726.726 0 0 1-.216-.534V8.558c0-.213.072-.39.216-.535a.727.727 0 0 1 .535-.215Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconFingerLine;
